import { LinkOutlined } from '@mui/icons-material';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';

import { useSnackbar } from '@/hooks/useSnackbar';
import { copyToClipboard } from '@/utils/clipboard/copyToClipboard';

import { graphql, type DocumentType } from '@/gql';
import { env } from '@/env';

const POST_COPY_LINK_MENU_ITEM_POST_FRAGMENT = graphql(`
  fragment postCopyLinkMenuItemPostFragment on Post {
    _id
  }
`);

const POST_COPY_LINK_MENU_ITEM_GROUP_FRAGMENT = graphql(`
  fragment postCopyLinkMenuItemGroupFragment on Group {
    _id
    machineName
  }
`);

interface Props {
  post: DocumentType<typeof POST_COPY_LINK_MENU_ITEM_POST_FRAGMENT>;
  group: DocumentType<typeof POST_COPY_LINK_MENU_ITEM_GROUP_FRAGMENT>;
  onClose: () => void;
}

export const PostCopyLinkMenuItem = ({ post, group, onClose }: Props) => {
  const { _id: postId } = post;
  const { machineName } = group;

  const { enqueueSnackbar } = useSnackbar();

  const handleCopy = async () => {
    const link = `${env.NEXT_PUBLIC_APP_URL}/g/${machineName}/post/${postId}`;
    await copyToClipboard(link, enqueueSnackbar);
    onClose();
  };

  return (
    <MenuItem onClick={handleCopy}>
      <ListItemIcon>
        <LinkOutlined />
      </ListItemIcon>
      <ListItemText
        primary="Copy link to clipboard"
        secondary="Copy a permanent link to this post"
      />
    </MenuItem>
  );
};
